/**
 * Paths that no longer exist but that installed copies of the app still open.
 *
 * `/events` was the PWA manifest's `start_url` until the portal moved to the
 * shared shell and the dashboard became the start page. A manifest is read at
 * install time — on iOS a home-screen app never re-reads it — so every phone
 * that added the portal before that still launches at `/events` and lands on
 * the 404 page. The app shell itself loads fine, which is why "Go back home"
 * has always worked; only the route was gone.
 */
const LEGACY_ROUTES: Record<string, string> = {
  '/events': '/dashboard'
}

export default defineNuxtRouteMiddleware((to) => {
  const target = LEGACY_ROUTES[to.path]

  // replace, so the dead path does not sit in history behind the dashboard and
  // come back on the first Back press.
  if (target) return navigateTo({ path: target, query: to.query }, { replace: true })
})
